import { render, staticRenderFns } from "./jenisUsaha.vue?vue&type=template&id=0a5d5a02&"
import script from "./jenisUsaha.vue?vue&type=script&lang=js&"
export * from "./jenisUsaha.vue?vue&type=script&lang=js&"
import style0 from "./jenisUsaha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QMarkupTable,QPagination,QDialog,QCard,QCardSection,QImg,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QMarkupTable,QPagination,QDialog,QCard,QCardSection,QImg,QCardActions,QBtn})
